var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedRequiredAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 4,
    viewBox: "0 0 5 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.9773 3.776L1.4163 3.369L2.0543 2.291L0.932297 1.796L1.1413 1.136L2.3403 1.411L2.4613 0.168H3.1543L3.2753 1.411L4.4853 1.136L4.6943 1.796L3.5613 2.291L4.1993 3.369L3.6383 3.776L2.8133 2.819L1.9773 3.776Z",
    fill: "#E73B19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRequiredAsterisk);
export default __webpack_public_path__ + "static/media/red-required-Asterisk.b3d257df3a6967ffd86d4e713d435e65.svg";
export { ForwardRef as ReactComponent };